import { getConstanceSettings } from '@disco/state-management/selectors/user'

import { useSelector } from 'hooks/use-redux'

/**
 * Gates the Explorer right-click context menus (playlists, tracks, briefs,
 * brief projects, channel folders) behind a Constance setting so the
 * rollout can be staged without a redeploy.
 */
export const useExplorerContextMenusEnabled = (): boolean => {
  const constanceSettings = useSelector(getConstanceSettings)
  return Boolean(constanceSettings?.EXPLORER_RIGHT_CLICK_CONTEXT_MENUS)
}
